import { ClassSegmentEnumerator, ClassYearEnumerator, ClassCollectionEnumerator } from '../enumerators';

export class ClassYear {
  year: ClassYearEnumerator;
  collection: ClassCollectionEnumerator;
  segment: ClassSegmentEnumerator;
}